import { render } from "./BattlesCreate.vue?vue&type=template&id=63b82b68&scoped=true"
import script from "./BattlesCreate.vue?vue&type=script&lang=js"
export * from "./BattlesCreate.vue?vue&type=script&lang=js"

import "./BattlesCreate.vue?vue&type=style&index=0&id=63b82b68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b82b68"]])

export default __exports__